var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"can",attrs:{"id":"canvas","width":"2000","height":"600"}}),_c('span',{ref:"toolTip",staticClass:"toolTip"},[_vm._v("ToolTip")])])}
var staticRenderFns = []

export { render, staticRenderFns }